try {
    if (process.env.TOKENS_FEATURE_FLAG === 'true' || process.env.STORYBOOK_TOKENS_FEATURE_FLAG !== 'false') require('./index-new.css');
    else require('./index.css');
  } catch (e) {
    if (e.code !== 'MODULE_NOT_FOUND') {
      throw e; // Re-throw unexpected errors
    }
    console.warn('index.css / index-new.css not found, proceeding without it.');
  }


import { jsxs, jsx } from 'react/jsx-runtime';
import classNames from 'classnames';
import { forwardRef } from 'react';
import { ExtendableImage } from '@design-system/extendable-image';
import { Typography } from '@design-system/typography';

const Trait = forwardRef(({ className, description, image, direction, size, textAlign, withBackground, }, ref) => {
    const classes = classNames('cds-trait', className, { 'cds-trait--with-background': withBackground }, `cds-trait--${direction}`, `cds-trait--${size}`);
    return (jsxs("div", Object.assign({ ref: ref, className: classes, "data-testid": "cds-trait" }, { children: [image && jsx(ExtendableImage, Object.assign({}, image, { className: "cds-trait__image" })), jsx(Typography, { className: "cds-trait__description", align: textAlign, content: description, variant: "body", size: "xs", weight: "light", tag: "p" })] })));
});

const TraitGroup = forwardRef(({ className, items, direction, size, textAlign, withBackground }, ref) => (jsx("div", Object.assign({ ref: ref, className: classNames('cds-trait-group', className), "data-testid": "cds-trait-group" }, { children: items.map(({ image, description }, index) => (jsx(Trait, { image: image, description: description, direction: direction, size: size, textAlign: textAlign, withBackground: withBackground }, index))) }))));

export { TraitGroup };
